import { render, staticRenderFns } from "./AppTags.vue?vue&type=template&id=60fca920&"
import script from "./AppTags.vue?vue&type=script&lang=js&"
export * from "./AppTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports